import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui/Button';
import { Checkbox } from '@/components/ui/Checkbox';
import { Modal } from '@/components/ui/Modal';
import { TYPE } from '@/lib/typography';
import { cn } from '@/utils/cn';

export function CancelTreatmentCourseModal({
  open,
  onClose,
  onConfirm,
  pending = false,
  sendEmail,
  onSendEmailChange,
  zzTestPatient = false,
}: {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  pending?: boolean;
  sendEmail: boolean;
  onSendEmailChange: (value: boolean) => void;
  zzTestPatient?: boolean;
}) {
  const { t } = useTranslation();

  return (
    <Modal
      open={open}
      onClose={onClose}
      tone="danger"
      showIcon
      role="alertdialog"
      title={t('treatment_courses.patient_cancel_course')}
      description={t('treatment_courses.patient_cancel_course_hint')}
      footer={
        <>
          <Button type="button" variant="secondary" onClick={onClose} disabled={pending}>
            {t('treatment_courses.patient_cancel_course_keep')}
          </Button>
          <Button
            type="button"
            variant="danger"
            onClick={onConfirm}
            loading={pending}
            loadingText={t('treatment_courses.patient_cancel_course_confirming')}
          >
            {t('treatment_courses.patient_cancel_course_confirm')}
          </Button>
        </>
      }
    >
      <Checkbox
        id="cancel-course-send-email"
        checked={sendEmail}
        onChange={(event) => onSendEmailChange(event.target.checked)}
        label={t('treatment_courses.patient_cancel_course_send_email')}
        hint={
          zzTestPatient
            ? t('treatment_courses.patient_cancel_course_zztest_hint')
            : t('treatment_courses.patient_cancel_course_send_email_hint')
        }
      />
      <p className={cn(TYPE.small, 'mt-s4 text-ds-muted')}>
        {t('appointments.cancel_modal.payment')}
      </p>
    </Modal>
  );
}
